import { render } from "./BaseNoResults.vue?vue&type=template&id=2ebab039&scoped=true"
import script from "./BaseNoResults.vue?vue&type=script&lang=js"
export * from "./BaseNoResults.vue?vue&type=script&lang=js"

import "./BaseNoResults.vue?vue&type=style&index=0&id=2ebab039&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebab039"]])

export default __exports__